module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"title":"","copy":{"one":"","two":"","three":""},"cta":""},"es-MX":{"title":"Fiesta","copy":{"one":"20:00 hrs","two":"Florida Eventos","three":"¿Cómo llegar?"},"cta":"Ubicación"}}')
  delete Component.options._Ctor
}
